<template>
  <div>
    <div class="Remarks">10秒免费帮您预约精选设计师</div>
    <div class="forms">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入您的电话号码" :maxlength=11></el-input>
        </el-form-item>
         <el-form-item prop="address">
          <el-input v-model="ruleForm.address" placeholder="请输入您的地址" ></el-input>
        </el-form-item>
        <el-form-item prop="measure">
          <el-input v-model="ruleForm.measure" placeholder="请输入您的房屋面积" ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary">预约设计</el-button>
      </div>

    </div>
    <div class="Tips">今日已有<span class="Tipsnum">20</span>人预约设计</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        phone:'',
        address:'',
        measure:'',
      },
      rules: {
        name: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入您的电话号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的电话号码", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入您的地址", trigger: "blur" },
          { min: 2, max: 19, message: "请输入正确的地址", trigger: "blur" }
        ],
        measure: [
          { required: true, message: "请输入您的房屋面积", trigger: "blur" },
          { min: 2, max: 19, message: "请输入正确的房屋面积", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style scoped>
.Remarks{
  width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
}
.el-button--primary {
    color: #FFF;
    background-color: #b31d25;
    border-color: #b31d25;
    width: 80%;
}
.forms>>>.el-form-item__content {
  margin-left: 0px !important;
}
.el-input{
  width: 80%;
}
.forms>>>.el-form-item__error{
  position: absolute;
  left: 33px;
}
.btn{
  margin-top: 50px;
}
.Tips{
  width: 100%;
  margin-top: 30px;
}
.Tipsnum{
  color: #b31d25;
}
</style>
